

Ladder ID:
<input [formControl]="ladderId" />
<br />
Ladder Name:
<input [formControl]="name" />
<br />

From:
<mat-form-field>
  <mat-label>Choose a date</mat-label>
  <input matInput [matDatepicker]="picker" [formControl]="startDate">
  <mat-hint>MM/DD/YYYY</mat-hint>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
<br />
To:
<mat-form-field>
  <mat-label>Choose a date</mat-label>
  <input matInput [matDatepicker]="picker2" [formControl]="endDate">
  <mat-hint>MM/DD/YYYY</mat-hint>
  <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
  <mat-datepicker #picker2></mat-datepicker>
</mat-form-field>


<br />


Forfeit:
<select [formControl]="forfeitPoints" >
  <option [value]="2">2</option>
  <option [value]="3">3</option>
  <option [value]="4">4</option>
  <option [value]="5">5</option>
</select>
<br />

Type:
<select [formControl]="type" >
  <option [value]="'Normal'">Normal</option>
  <option [value]="'Tiebreak'">Tiebreak</option>
  <option [value]="'WaitingRoom'">WaitingRoom</option>
</select>
<br /><br /><br />

<button (click)="submit($event)" [disabled]="fg.invalid">Create Ladder</button>
{{msg}}